import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=331812bb&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331812bb')) {
      api.createRecord('331812bb', component.options)
    } else {
      api.reload('331812bb', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=331812bb&", function () {
      api.rerender('331812bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4TWBw0fvk4dfd/JS/IncreaseNumber.vue"
export default component.exports